import {history} from "../helpers/history"

export function setFirstDate(date) {
  return {type: "SET_WEEK_DATE", payload: date}
}

export function setDate(date) {
  return function(dispatch) {
    dispatch({type: "SET_WEEK_DATE", payload: date})

    history.push(`/week/${date.format('YYYYMMDD')}`)
  }
}

export function nextWeek(date) {
  return function(dispatch) {
    const newDate = date.clone().add(1, 'weeks')
    dispatch({type: "SET_WEEK_DATE", payload: newDate})

    history.push(`/week/${newDate.format('YYYYMMDD')}`)
  }
}

export function previousWeek(date) {
  return function(dispatch) {
    const newDate = date.clone().add(-1, 'weeks')
    dispatch({type: "SET_WEEK_DATE", payload: newDate})

    history.push(`/week/${newDate.format('YYYYMMDD')}`)
  }
}



// WEBPACK FOOTER //
// ./src/js/actions/weekActions.js